import { render, staticRenderFns } from "./PersonalDataFormsAccordion.vue?vue&type=template&id=a1b1ad98&scoped=true"
import script from "./PersonalDataFormsAccordion.vue?vue&type=script&lang=ts"
export * from "./PersonalDataFormsAccordion.vue?vue&type=script&lang=ts"
import style0 from "./PersonalDataFormsAccordion.vue?vue&type=style&index=0&id=a1b1ad98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b1ad98",
  null
  
)

export default component.exports